import { Calendar } from "lucide-react";
import { Button } from "@/components/common/Button";
import { KeyDatesTable } from "@/components/common/KeyDatesTable";

import {
  FEE_SECTION,
  REGISTRATION_NOTICE,
  KEY_DATES,
} from "@/constants";

import { useExamFee } from "@/context/ExamFeeContext";

export function FeeAndNotice() {
  const { examFee, loading: examFeeLoading } = useExamFee();

  const feeText =
    examFeeLoading || examFee === null
      ? "—"
      : `₹${examFee}`;

  return (
    <section className="bg-slate-50/60 py-12 sm:py-20 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 sm:space-y-8">

        {/* =====================================================
            FEE SECTION
        ====================================================== */}

        <div className="w-full rounded-2xl border border-slate-200 bg-white p-5 sm:p-9 shadow-sm">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">
            {FEE_SECTION.heading}
          </h2>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between rounded-xl bg-amber-50 border border-amber-200 px-4 py-4 sm:px-6 sm:py-5">
            <div className="text-sm font-semibold text-slate-600">
              {FEE_SECTION.category}
            </div>

            <div className="sm:text-right">
              <div className="font-heading text-3xl sm:text-4xl font-extrabold text-slate-900">
                {feeText}
              </div>

              <div className="text-xs text-slate-500">
                (inclusive of applicable charges)
              </div>
            </div>
          </div>

          <p className="mt-5 text-sm text-slate-600 leading-relaxed break-words">
            {FEE_SECTION.note}
          </p>

          <div className="mt-6">
            <Button to="/apply" data-testid="fee-apply-btn">
              Apply for Exam
            </Button>
          </div>
        </div>

        {/* =====================================================
            NOTICE + KEY DATES
        ====================================================== */}

        <div className="w-full rounded-2xl border border-amber-200 bg-[#FFFBEB] p-5 sm:p-9">

          {/* Notification Header */}

          <div className="flex items-center gap-2 text-amber-700 mb-3">
            <Calendar className="h-5 w-5 shrink-0" />

            <span className="text-xs font-bold uppercase tracking-widest">
              Official Notification
            </span>
          </div>

          <h2 className="font-heading text-xl sm:text-2xl font-bold text-slate-900">
            {REGISTRATION_NOTICE.heading}
          </h2>

          <p className="mt-3 text-sm text-slate-600 leading-relaxed break-words">
            {REGISTRATION_NOTICE.body}
          </p>

          {/* Key Dates */}

          <div className="mt-6 w-full">
            <KeyDatesTable
              rows={KEY_DATES}
              testId="key-dates-table"
            />
          </div>
        </div>

      </div>
    </section>
  );
}